import { Injectable} from '@angular/core';
import { HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import { environment } from 'src/app/model/constants';
import { ICarouselHomeImages, ICarouselHomeImagesResponse, ICarouselHomePoojaResponse } from './home.interface';

@Injectable()
export class HomeApiService {
  constructor(
    private http: HttpClient,
  ) {
  }

  // tslint:disable-next-line:no-inferrable-types
  private url = environment.baseUrl;

  public getHomePageBanners(): Observable<ICarouselHomeImagesResponse> {
    return this.http.get<ICarouselHomeImagesResponse>(`${this.url}/getHomeBanner`);
  }

  // public getHomePageText(): Observable<ICarouselHomeImagesResponse> {
  //   return this.http.get<ICarouselHomeImagesResponse>(`${this.url}/getHomeTexts`);
  // }

  public getHomePagePoojaData(): Observable<ICarouselHomePoojaResponse> {
    return this.http.get<ICarouselHomePoojaResponse>(`${this.url}/getHomePujaList`);
  }

  public getHomePageShaktipeethTVList(): Observable<ICarouselHomeImagesResponse> {
    return this.http.get<ICarouselHomeImagesResponse>(`${this.url}/getHomeShaktipeethTVList`);
  }

  public getAppPlaceHolder(): Observable<ICarouselHomeImagesResponse> {
    return this.http.get<ICarouselHomeImagesResponse>(`${this.url}/getAppPlaceHolder`);
  }

  public getCMSOurService(): Observable<ICarouselHomeImagesResponse> {
    return this.http.get<ICarouselHomeImagesResponse>(`${this.url}/getCMSOurService`);
  }

  public getTestimonialList(): Observable<ICarouselHomeImagesResponse> {
    return this.http.get<ICarouselHomeImagesResponse>(`${this.url}/getAllTestimonial`);
  }

  public homePageEnquiry(data: any): Observable<ICarouselHomeImagesResponse> {
    return this.http.post<ICarouselHomeImagesResponse>(`${this.url}/homePageEnquiry`, data);
  }

}
